export const layoutNavbarLinks = [
  { name: 'nav.pferdesport', navPart: 'equine-sport', url: 'reitsport' },
  { name: 'nav.hundesport', navPart: 'dog-sport', url: 'hundesport' },
  { name: 'nav.bootsport', navPart: 'boat-sport', url: 'bootsport-vc-17m-verbot' },
  { name: 'nav.collections', navPart: 'collections' },
  { name: 'nav.faq', navPart: 'faq', url: 'faq' },
  { name: 'nav.magazin', navPart: 'about', url: 'magazin' },
];
